import styled from 'styled-components/macro';

export const Root = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 32px;
  text-align: center;
`;
